var NearScheduleModalEnum = /* @__PURE__ */ ((NearScheduleModalEnum2) => {
  NearScheduleModalEnum2["NEAR_SCHEDULE_MODAL"] = "near-schedule-modal";
  NearScheduleModalEnum2["NEAR_SCHEDULE_MODAL_CLOSE"] = "near-schedule-modal-close";
  NearScheduleModalEnum2["NEAR_SCHEDULE_MODAL_TITLE"] = "near-schedule-modal-title";
  NearScheduleModalEnum2["NEAR_SCHEDULE_MODAL_DESCRIPTION"] = "near-schedule-modal-description";
  NearScheduleModalEnum2["NEAR_SCHEDULE_MODAL_CONFIRM_BUTTON"] = "near-schedule-modal-confirm-button";
  NearScheduleModalEnum2["NEAR_SCHEDULE_MODAL_CANCEL_BUTTON"] = "near-schedule-modal-cancel-button";
  return NearScheduleModalEnum2;
})(NearScheduleModalEnum || {});
export {
  NearScheduleModalEnum
};
